{
  "bodyInputLabel": "Corpo",
  "bodyInputPlaceholder": "Descrivi il tuo problema:",
  "callUs": "Chiamaci",
  "cancel": "Cancellare",
  "chooseYourProduct": "Scegli il tuo prodotto",
  "contactUs": "Contattaci",
  "continue": "Continuare",
  "createSupportTicketDescription": "Crea un ticket di supporto nel nostro sistema per ottenere supporto diretto da uno dei nostri collaboratori.",
  "createSupportTicketHelpContentWithPhoneNumber": "I ticket di supporto vengono regolarmente esaminati e gestiti dal nostro team. Se preferisci parlare con qualcuno, puoi chiamarci al numero {{phoneNumber}}.",
  "createSupportTicketTitle": "Crea un ticket di supporto",
  "emailUs": "Inviaci un'e-mail",
  "exitAppPromptMessage": "Stai per andare su app.farmhq.com per accedere alla documentazione di supporto.",
  "exitAppPromptTitle": "Vuoi continuare su FarmHQ Web?",
  "farmHqIsHereToHelp": "FarmHQ è qui per aiutarti! Contattaci per qualsiasi problema tu possa avere e ti risponderemo il prima possibile.",
  "getHelpWithFarmHq": "Ottieni assistenza con FarmHQ",
  "sendUsAMessage": "Inviaci un messaggio",
  "shareFeedback": "Condividi feedback",
  "shareFeedbackDescription": "Raccontaci come funziona il nostro prodotto e come possiamo migliorarlo ulteriormente.",
  "subjectInputLabel": "Soggetto",
  "subjectInputPlaceholder": "Ho bisogno di aiuto con...",
  "support": "Supporto",
  "supportCenter": "Centro di supporto",
  "supportDocumentationLink": "Visualizza la documentazione di supporto",
  "title": "Centro di supporto",
  "topic_one": "Argomento",
  "topic_other": "Argomenti",
  "viewInstructionManual": "Visualizza il manuale di istruzioni",
  "viewSupportDocsDescription": "Leggi la documentazione sull'installazione, la risoluzione dei problemi, l'utilizzo dell'app e altri argomenti su app.farmhq.com.",
  "weHaveReceivedYourMessage": "Abbiamo ricevuto il tuo messaggio!"
}
